import { MealPlanningSessionList } from "@corpuscomplete/core-ui/nutrition/meal-planning-session/list";
import { MealPlanningSessionsPage } from "@corpuscomplete/web/modules/nutrition/meal-planning-session/pages/meal-planning-sessions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/spaces/$spaceId/meal-planning-sessions/")({
  loader: async ({ context: { zero }, params: { spaceId } }) => {
    if (!zero) return;
    MealPlanningSessionList.preload(zero, { scopeId: spaceId });
  },
  component: () => {
    const { spaceId } = Route.useParams();
    return <MealPlanningSessionsPage scope={{ kind: "space", spaceId }} />;
  },
});
